// extracted by mini-css-extract-plugin
export default {"changeDisclaimer":"PD-z","cltLink":"QD-z","shippingDisclaimer":"RD-z"};